import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { Tag } from 'models/tag';
import './tag.html';
import './tag.scss';

export interface TagsVMConfig {
    tag: SubscribableOrNullableValue<Tag>
    prefix?: SubscribableOrNullableValue<string>
    hideRoot?: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class TagVM {
    private isRootHidden: Subscribable<boolean>

    title: Subscribable<string | undefined>
    content: Subscribable<string | undefined>
    prefix: Subscribable<string | undefined>
    tagColor: Subscribable<string | undefined>
    fontColor: Subscribable<string | undefined>

    isHidden: Subscribable<boolean | undefined>

    constructor(
        @inject(wccModules.componentConfig) configOrTag: TagsVMConfig | Tag,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const config: TagsVMConfig = configOrTag instanceof Tag ? { tag: configOrTag } : configOrTag;

        const tag = ko.flattenComputed(config.tag);
        this.isRootHidden = ko.flattenComputed(config.hideRoot, false);

        this.title = tag.pluck(t => t.tagValue);
        this.content = tag.pluck(t => this.getTagContent(t));
        this.prefix = ko.flattenComputed(config.prefix);
        this.tagColor = tag.pluck(t => t.tagColor);
        this.fontColor = tag.pluck(t => t.tagColor).mapNotNull(system.calculateFontColor);
        this.isHidden = tag.pluck(t => t.isHidden);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-tag': true
            },

            'style': {
                'background-color': this.tagColor,
                'color': this.fontColor,
                'text-decoration': ko.pureComputed<string>(() => this.isHidden() ? 'line-through' : '')
            }
        });
    }

    private getTagContent(tag: Tag) {
        if (tag.isComplex() && this.isRootHidden())
            return tag.tagNoRootValueShort();

        return tag.tagValueShort();
    }
}